import { Action, createReducer, on } from '@ngrx/store';
import { UserPermActions } from '../actions';
import { UserPermStates } from '../states';
import { userPermAdapters, initialState } from '../states/user-permissions.states';

export const userPermReducer = createReducer(
    initialState,

    // load users in the user listing
    on(UserPermActions.loadUsersSuccess, (state, action) => ({...state, totalRecords: action.totalRecords})),
    on(UserPermActions.loadUsersFailure, (state, action) =>
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // load roles in the role listing
    on(UserPermActions.loadRolesSuccess, (state, action) => ({...state, totalRecords: action.totalRecords})),
    on(UserPermActions.loadRolesFailure, (state, action) =>
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // load permission set in the permission set listing
    on(UserPermActions.loadPermissionSetSuccess, (state, action) => ({...state, totalRecords: action.totalRecords})),
    on(UserPermActions.loadPermissionSetFailure, (state, action) =>
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    // update user
    on(UserPermActions.updateUserSuccess, (state, action) => ({...state, updateUserListing: true})),
    on(UserPermActions.updateUserFailure, (state, action) =>
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    on(UserPermActions.createPermSetSuccess, (state, action) => ({...state, updatePermSetListing: true})),
    on(UserPermActions.createPermSetFailure, (state, action) =>
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    on(UserPermActions.addPermSetSuccess, (state, action) => ({...state, updatePermSetListing: true})),
    on(UserPermActions.addPermSetFailure, (state, action) =>
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    on(UserPermActions.unlinkPermSetSuccess, (state, action) => ({...state, updatePermSetListing: true})),
    on(UserPermActions.unlinkPermSetFailure, (state, action) =>
    ({...state, errorLog: [...state.errorLog, {timeStamp: new Date(), log: action.error}]})),

    on(UserPermActions.setNewPermSet, (state, action) => ({...state, newPermSet: action.permSet})),
    on(UserPermActions.setPermTemplate, (state, action) => ({...state, selectedPermTemplate: action.permTemplate})),
    on(UserPermActions.selectCreatedPermSet, (state, action) => ({...state, selectedCreatedPermSet: action.permSet})),
    on(UserPermActions.selectCreatedPermSetLine, (state, action) => ({...state, selectedCreatedPermSetLine: action.permSetLine})),

    on(UserPermActions.setUpdatePermSetListing, (state, action) => ({...state, updatePermSetListing: action.update})),

    on(UserPermActions.setCurrentUser, (state, action) => ({...state, currentUser: action.currentUser})),
    on(UserPermActions.selectUser, (state, action) => ({...state, selectedUser: action.user})),
    on(UserPermActions.setUpdateUserListing, (state, action) => ({...state, updateUserListing: action.update})),

    on(UserPermActions.selectRole, (state, action) => ({...state, selectedRole: action.role})),
    on(UserPermActions.selectPermSet, (state, action) => ({...state, selectedPermSet: action.permSet})),
    on(UserPermActions.selectPermSetLine, (state, action) => ({...state, selectedPermSetLine: action.permSetLine})),

    on(UserPermActions.selectGuid, (state, action) => ({...state, selectedGuid: action.guid})),
    on(UserPermActions.setRequiresUpdate, (state, action) => ({...state, requiresUpdate: action.update})),
)

export function user_perm_reducer(state: UserPermStates | undefined, action: Action) {
    return userPermReducer(state.userPerm, action);
}
